module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainWeb"
  }, [_c('el-dialog', {
    attrs: {
      "title": "阈值设置",
      "visible": _vm.showyuzhi,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showyuzhi = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("私教课名称：" + _vm._s(_vm.yuzhiObj.courseName))]), _vm._v(" "), _c('el-form', {
    ref: "formparamsYuzhi",
    attrs: {
      "model": _vm.formparamsYuzhi,
      "rules": _vm.rules,
      "label-width": "135px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "提前提醒剩余次数",
      "prop": "minvalue"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入提前提醒次数"
    },
    model: {
      value: (_vm.formparamsYuzhi.minvalue),
      callback: function($$v) {
        _vm.$set(_vm.formparamsYuzhi, "minvalue", _vm._n($$v))
      },
      expression: "formparamsYuzhi.minvalue"
    }
  })], 1), _vm._v(" "), (_vm.iscourseDays) ? _c('el-form-item', {
    attrs: {
      "label": "过期提前提醒天数",
      "prop": "expireMinValue"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入过期提前提醒天数"
    },
    model: {
      value: (_vm.formparamsYuzhi.expireMinValue),
      callback: function($$v) {
        _vm.$set(_vm.formparamsYuzhi, "expireMinValue", _vm._n($$v))
      },
      expression: "formparamsYuzhi.expireMinValue"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetFormYuzhi('formparamsYuzhi')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormYuzhi('formparamsYuzhi')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "私教课程信息",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.isSelectShopNum) ? _c('el-form-item', {
    attrs: {
      "label": "分店",
      "prop": "shopNum"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectShopNum
    },
    model: {
      value: (_vm.formparams.shopNum),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "shopNum", $$v)
      },
      expression: "formparams.shopNum"
    }
  }, _vm._l((_vm.shopListNew), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "私教课价格",
      "prop": "actualPrice"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入私教课价格"
    },
    model: {
      value: (_vm.formparams.actualPrice),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "actualPrice", $$v)
      },
      expression: "formparams.actualPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "任课教练",
      "prop": "jid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择任课教练"
    },
    model: {
      value: (_vm.formparams.jid),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "jid", $$v)
      },
      expression: "formparams.jid"
    }
  }, _vm._l((this.optionsJL), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上课教室"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择上课教室"
    },
    model: {
      value: (_vm.formparams.classRoom),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "classRoom", $$v)
      },
      expression: "formparams.classRoom"
    }
  }, _vm._l((this.roomList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "私教课类型",
      "prop": "mode"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "私教类型（1V2/1V3 传1、2、3、4）",
      "maxlength": "20"
    },
    model: {
      value: (_vm.formparams.mode),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "mode", _vm._n($$v))
      },
      expression: "formparams.mode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程说明",
      "prop": "courseDetails"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.formparams.courseDetails),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "courseDetails", $$v)
      },
      expression: "formparams.courseDetails"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "私教图片",
      "visible": _vm.dialogVisible2,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparamsAddImg",
    attrs: {
      "model": _vm.formparamsAddImg,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "私教图片",
      "required": "",
      "prop": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n           *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。\n        ")], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm2('formparamsAddImg')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addForm('formparamsAddImg')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableDataOff,
      "height": "68vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "私教课程名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shortname",
      "label": "名称简写"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "scope": "scope",
      "label": "私教图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "imgList",
          staticStyle: {
            "width": "70px",
            "height": "70px"
          },
          attrs: {
            "src": 'http://zlesp.zlydgy.cn:8091/images/' + scope.row.imgurl,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemprice",
      "label": "私教课程金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAllShop == '否') ? _c('div', [_vm._v(_vm._s(_vm._f("changeType")(scope.row.shopNum)))]) : _c('div', [_vm._v("通用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "350",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改图片")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.setThreshold(scope.row)
            }
          }
        }, [_vm._v("阈值设置")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state != 1),
            expression: "scope.row.state!=1"
          }],
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.addOnlineCard(scope.row)
            }
          }
        }, [_vm._v("上线")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8032edc8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/coach/offlineCoach.vue
// module id = 621
// module chunks = 70